import awords from "../../image/AWARDS.jpg"

export const AppreciationData = [
    {
        id:1,
        url: awords,
        name: "name"
    }
]